const user = {
  en: {
    updatePermission: "Update permission.",
  },
  pt: {
    updatePermission: "Permissão atualizada.",

  },
  es: {
    updatePermission: "Permiso de actualización.",

  }
};

export default {
  ...user
}



// WEBPACK FOOTER //
// ./src/app/user/i18nUser.js